import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, doc, setDoc, updateDoc } from "firebase/firestore";

function Reiniciar_valores_gastos(valor) {
  console.log(valor)
  const db = getFirestore(firebaseApp);
  let collectionRef = collection(db, "Gastos".replace(/ /g, ""))
  const docRef = doc(collectionRef, valor.nombre);
  updateDoc(docRef, {
    valor : 0
  });
  
}

export default Reiniciar_valores_gastos;
